import { type IApplicationContext } from '@/app/shared/types/ApplicationContext';

import { type IReduxStateProvider } from '../IReduxStateProvider';

import { ReduxState } from './ReduxState';

export class BrowserReduxState extends ReduxState implements IReduxStateProvider {
  public constructor(context: IApplicationContext) {
    const {
      config,
      custom: { isTestMode },
    } = context;

    super(config.getStrict(ReduxState.key), isTestMode);
  }
}
